import styled, { keyframes } from 'styled-components'
import Link from 'next/link'
import RootContainer from '@styles/Container'
import { H4 } from '@components/Heading'
import Text from '@components/Text'
import Button from '@components/Button'
import { up } from 'styled-breakpoints'

const animation = keyframes`
  from {
    background-position-y: 0;
  }

  to {
    background-position-y: 100%;
  }
`

const Pattern = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  position: absolute;
  top: 0;
  left: 0;
  width: 200%;
  height: 200%;
  transform: rotate(30deg) translate(-45%, -7%);
  transform-origin: center;
  z-index: 1;

  ${up('md')} {
    width: 160%;
    height: 200%;
    transform: rotate(30deg) translate(-25%, -7%);
  }

  div {
    background-image: url('images/pattern.png');
    background-size: 100% auto;
    animation: ${animation} 30s linear infinite;

    &:nth-child(1),
    &:nth-child(3),
    &:nth-child(5) {
      animation-direction: reverse;
    }

    &:nth-child(1) {
      animation-duration: 50s;
    }

    &:nth-child(2) {
      animation-duration: 80s;
    }

    &:nth-child(3) {
      animation-duration: 60s;
    }

    &:nth-child(4) {
      animation-duration: 70s;
    }

    &:nth-child(5) {
      animation-duration: 110s;
    }

    &:nth-child(6) {
      animation-duration: 90s;
    }
  }
`

const Container = styled.div`
  position: relative;
  background: hsl(0, 0%, 0%);
  overflow: hidden;
  padding: 14rem 0;

  ${up('md')} {
    padding: 24.6rem 0;
  }

  &::after,
  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    bottom: 0;
    z-index: 2;
  }

  &::after {
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
    height: 50%;
  }

  &::before {
    background: hsla(0, 0%, 0%, 0.84);
  }
`

const Title = styled(H4)`
  margin: 0 0 2.4rem;
`

const TextContent = styled(Text)`
  margin: 0 0 5.6rem;
`

const Content = styled.div`
  display: block;
  position: relative;
  z-index: 3;

  ${up('md')} {
    max-width: 35rem;
    margin: 0 0 0 auto;
  }

  ${Title},
  ${TextContent} {
    color: hsl(0, 0%, 100%);
  }
`

const FooterProjectsCTA: React.FC = () => (
  <Container>
    <Pattern>
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </Pattern>
    <RootContainer>
      <Content>
        <Title>Cooperation with well-known brands</Title>
        <TextContent>
          Over the course of a thousand projects we have worked with various
          international and local brands, on both short and long-term projects.
        </TextContent>
        <Link href="/work" passHref>
          <Button as="a" text="See all projects" theme="red" />
        </Link>
      </Content>
    </RootContainer>
  </Container>
)

export default FooterProjectsCTA
